import logo from './logo.svg';
import NameComponent from './components/NameComponent';
import './App.css';

function App() {
  return (
      <NameComponent></NameComponent>
  );
}

export default App;
